import {ControllerBase} from "../../../controllerBase";
import {Paginator} from "../../../paginator";
const ko = require('knockout')

declare var window:any

export const listaCepController = ControllerBase.extend({
    name: 'listaCepController',
    framework: 'knockout',
    bindingRegion: "#lista-cep-binding",
    ajax: function () {
        return {
            url: "/Comum/_ListaCep",
            type: "post",
            cache: false,
        };
    },

    initialize: function () {
        if (typeof this.data != "undefined") {
            this.appendToModel({ name: "listaCep", value: this.data.Entities });
        }
    },

    aposBinding: function () {
        this.mostrarModal();
        if (typeof this.data != "undefined") {
            this.atualizarPaginador(this.data);
        }
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    mostrarModal: function () {
        $("#modalListaCep").modal("show");
    },

    selecionarCep: function (model) {
        if (typeof this.callback != "undefined") {
            this.callback(model.Cep());
        }
        $("#modalListaCep").modal("hide");
    },

    paginar: function (e) {
        if (typeof this.pesquisar != "undefined") {
            var data = this.pesquisar(null, e.page, null, $.proxy(this.atualizarModel, this));
        }
    },

    atualizarModel: function (data) {
        var m = ko.mapping.fromJS(data.Entities);

        this.model.listaCep(m());
        this.atualizarPaginador(data);

    },

    atualizarPaginador: function (data) {

        this.paginador = new Paginator({
            container: "#page-lista-cep",
            data: data,
            pageClickCallback: $.proxy(this.paginar, this)
        });

    },

});

window.listaCepController = listaCepController
